module.exports = __webpack_public_path__ + "img/nzavo-thumb.bbeb9ad7.jpg";